/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 13);
/******/ })
/************************************************************************/
/******/ ({

/***/ 13:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("KeTs");


/***/ }),

/***/ "KeTs":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var mixin = {
	data: {
		form_errors: [],
		form_status: '',
		account_type: null,
		userAddress: {},
		acctAddress: {},
		accounts: 'No',
		first_nm: '',
		last_nm: '',
		user_title: '',
		email: '',
		phone1: '',
		phone2: '',
		password: '',
		password_confirmation: '',
		company_nm: '',
		industry_list: [],
		analysis_industry: '',
		regulatory_samples: false,
		initial_saved_address: {},
		verified_email: '',
		verify_user_status: '',
		is_processing: false,
		sample_desc: '',
		how_heard: {},
		how_heard_comment: '',
		company_website: '',
		registration_complete: false,
		exempt: false
	},
	computed: {
		howHeardValue: function howHeardValue() {
			if (this.how_heard.comment === true) {
				return this.how_heard.option && this.how_heard_comment ? this.how_heard.option + ' - ' + this.how_heard_comment : '';
			} else {
				return this.how_heard.option ? this.how_heard.option : '';
			}
		},

		// Register button is disabled if it's processing the request or something is invalid on the form
		register_button_disabled: function register_button_disabled() {
			return this.is_processing || !this.first_nm || !this.last_nm || !this.email || !this.phone1 || !this.userAddress.address1 || !this.userAddress.city || !this.password || !this.password_confirmation || this.password !== this.password_confirmation || !this.howHeardValue;
		}
	},
	methods: {
		updateAddress: function updateAddress(address) {
			this.userAddress = address;
		},
		submitForm: function submitForm() {
			if (this.register_button_disabled) {
				return;
			}

			this.is_processing = true;
			this.form_errors = [];
			var vm = this;

			this.$http.post('/register', {
				first_nm: this.first_nm,
				last_nm: this.last_nm,
				email: this.email,
				phone1: this.phone1,
				phone2: this.phone2,
				user_address: this.userAddress,
				password: this.password,
				password_confirmation: this.password_confirmation,
				how_heard: this.howHeardValue
			}).then(function (data) {
				vm.is_processing = false;
				vm.form_status = data.body.status;
				if (this.form_status) {
					this.registration_complete = true;
				} else {
					window.location.href = '/login-form';
				}
			}).catch(function (data, status, request) {
				vm.form_errors = data.data.errors;
				vm.is_processing = false;
				if (!vm.form_errors) {
					vm.form_errors = ['Error Saving Registration'];
				}
				location.href = '#top';
			});
		}
	},
	mounted: function mounted() {
		var docUser = document.getElementById('myLab-register-user');
		if (docUser && docUser.innerHTML) {
			var user = JSON.parse(docUser.innerHTML);
			this.status_cd = user.status_cd;
			this.email = user.email;
			this.first_nm = user.first_nm;
			this.last_nm = user.last_nm;
			this.phone1 = user.phone1;
			this.phone2 = user.phone2;

			this.initial_saved_address = {
				state_cd: user.state_cd,
				address1: user.address1,
				address2: user.address2,
				city: user.city,
				postal_cd: user.postal_cd,
				county: user.county,
				country_cd: user.country_cd,
				is_residential: user.is_residential
			};
		}

		var industries = document.getElementById('myLab-register-industries');
		if (industries && industries.innerHTML) {
			this.industry_list = JSON.parse(industries.innerHTML);
		}
	}
};

if (!window.myLabMixins) {
	window.myLabMixins = [];
}

window.myLabMixins.push(mixin);

/***/ })

/******/ });


// WEBPACK FOOTER //
// /js/auth/register.2f02413887b2c7e52430.js